import { config } from '@abyss/ui/tools/config';

const { LagoonSDK } = require('./lagoonSDK');

const ppdNamespace = 'sde-ppd';
const ppdSchema = {
  loadTables: true,
  loadForms: false,
};

const APP_ENV = config('APP_ENV');
const lagoonEnv = APP_ENV === 'local' ? 'dev' : APP_ENV;

export const ppdLagoon = new LagoonSDK(ppdNamespace, lagoonEnv, ppdSchema);
